module.exports = __webpack_public_path__ + "videos/harmony_lg.6bd2380.mp4";